import script from "./BookingConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./BookingConfirmation.vue?vue&type=style&index=0&id=38c250bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c250bc"]])

export default __exports__